module.exports = __webpack_public_path__ + "static/media/logo.fe27113e.png";